import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React, { FunctionComponent } from 'react';
import { GenericCheckbox } from '../../../../../components/Form/GenericCheckbox/GenericCheckbox';
import { colors } from '../../../../../theme/theme';

const useStyles = makeStyles((theme: Theme) => ({
	confirmationWrapper: {
		display: 'flex',
		alignItems: 'flex-start',
	},
	checkboxWrapper: {
		display: 'flex',
		height: 82,
		position: 'relative',
		top: theme.spacing(4),
		left: 0,
	},
	text: {
		marginLeft: theme.spacing(3),
	},
	textWithErrors: {
		color: colors.red,
	},
	errorMessage: {
		color: colors.red,
		fontSize: 14,
		borderTop: `1px solid ${colors.red}`,
		marginTop: theme.spacing(1),
		padding: theme.spacing(1, 1, 1, 0),
		display: 'inline-block',
	},
}));

interface Props {
	content: any;
	title: string;
	error: string;
	buttonMessage: string;
	checkedCheckbox: boolean;
	setCheckedCheckbox: any;
	nonContenfulExtraContent?: any;
	'data-cy'?: string;
}

const AgreementContainer: FunctionComponent<Props> = (props) => {
	const { content, error } = props;
	const { checkedCheckbox, setCheckedCheckbox } = props;
	const classes = useStyles();

	return (
		<div className={classes.confirmationWrapper} data-cy={props['data-cy']}>
			<div className={classes.checkboxWrapper}>
				<GenericCheckbox
					checked={checkedCheckbox}
					setChecked={setCheckedCheckbox}
				/>
			</div>
			<div className={`${classes.text} ${error ? classes.textWithErrors : ''}`}>
				<Typography variant="h3">{props.title}</Typography>
				{documentToReactComponents(content)}
				{props.nonContenfulExtraContent}
				{error && <div className={classes.errorMessage}>{error}</div>}
			</div>
		</div>
	);
};

export default AgreementContainer;
